import React, { Component } from "react";
import { observer } from "mobx-react";
import StarRating from "./shared/StarRating";
import store from "./store";

@observer
class Header extends Component {
  componentDidMount() {
    store.getHeaderStats();
  }

  render() {
    const { averageRating, numReviews } = store.headerStats;
    const dest = this.props.dest || "/reviews";

    if (!averageRating || !numReviews) {
      return null;
    }

    const displayRating = averageRating.toFixed(1);

    return (
      <div className="reviews-header" ref={"corp-header"}>
        <div className="rating">
          <span>{displayRating}</span>
          <StarRating rating={displayRating} width={"100%"} />
        </div>
        <div className="rating-count">
          (<a href={dest}>{numReviews} Ratings & Reviews</a>)
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js